module.exports = "\n\n\n\n\n\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/src/app/authorization-component/authorization-component.component.html
// module id = ../../../../../src/app/authorization-component/authorization-component.component.html
// module chunks = 0